import { createRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { authenticatedRoute } from '@/authenticated-route';
import { beforeLoadRouterGuard } from '@/integrations/tanstack-router/before-load-router-guard';
import { NOTICE_ROUTES } from './consts/routes';

const noticeSearchParams = z.object({
  noticeId: z.string().optional(),
  categoryId: z.string().optional(),
  startDatetime: z.string().optional(),
  endDatetime: z.string().optional(),
  createUser: z.string().optional(),
});

export type NoticeSearchParams = z.infer<typeof noticeSearchParams>;

// TODO: replace with actual permission once generated/permissions.ts includes notice
const NOTICE_PERMISSIONS: [] = [];

export const noticeRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: NOTICE_ROUTES.index,
  beforeLoad: beforeLoadRouterGuard(NOTICE_PERMISSIONS),
  validateSearch: zodValidator(noticeSearchParams),
}).lazy(() => import('./notice').then(({ Route }) => Route));
